// src/components/SplashScreen.tsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../contexts/AuthContext";

const SPLASH_DISPLAY_TIME_MS = 2000; // Reduced to 2 seconds for better UX

// Styled components for a modern splash screen
const SplashContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: #fff;
  text-align: center;
  padding: 30px;
`;

const LogoImage = styled.img`
  width: 200px;
  height: 100px;
  object-fit: contain;
  border-radius: 20px;
  margin-bottom: 20px;
  background: #fff;
`;

const Tagline = styled.p`
  font-size: 2.5rem;
  margin: 0;
`;

const SplashScreen: React.FC = () => {
  const { user, loading } = useAuth();
  const [redirect, setRedirect] = useState<boolean>(false);
  const [redirectPath, setRedirectPath] = useState<string>("/auth/login");

  useEffect(() => {
    // If user is already authenticated, determine redirect path based on role
    if (user && !loading) {
      let path = "/auth/login";
      
      if (user.role === 'admin') {
        path = "/admin";
      } else if (user.role === 'content_creator') {
        path = "/content-creator/dashboard";
      } else if (user.role === 'teacher') {
        path = "/teacher/dashboard";
      } else if (user.role === 'competitor') {
        path = "/app/compete/dashboard";
      } else if (user.onboardingCompleted) {
        path = "/app/dashboard";
      } else {
        path = "/onboarding";
      }
      
      setRedirectPath(path);
      // Redirect immediately for authenticated users
      setRedirect(true);
    } else if (!loading) {
      // Only show splash for unauthenticated users
      const timer = setTimeout(() => {
        setRedirect(true);
      }, SPLASH_DISPLAY_TIME_MS);
      return () => clearTimeout(timer);
    }
  }, [user, loading]);

  if (redirect) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <SplashContainer>
      <LogoImage src="/lavernAi_parent_logo.jpeg" alt="LavernAI Logo" />
      <Tagline>
        Lavern Titan - Connect, Learn & Earn !
      </Tagline>
    </SplashContainer>
  );
};

export default SplashScreen;
